import { match } from 'ts-pattern';
import type { FilterConfigItemBasic } from '../../../../../../lib/api/filterConfig';
import {
  AgeRangeComponent,
  InsuranceProviderComponent,
  NetWorthComponent,
  PatientAgeRangeComponent,
  PatientFacilityComponent,
  PatientGenderComponent,
  PatientStateComponent,
  StateNameComponent,
  YearsPracticedRangeComponent,
} from '../FilterConfigCustomComponents';
import type { FilterConfigItem } from '../FilterConfigTypes';

const extendFilter = (filter: FilterConfigItemBasic) => {
  const filterConfigExtension = match<FilterConfigItem | null>(filter)
    .with({ filterName: 'patient_age_range_filter' }, () => ({
      customComponent: PatientAgeRangeComponent,
    }))
    .with({ filterName: 'patient_insurance_provider_name_filter' }, () => ({
      customComponent: InsuranceProviderComponent,
    }))
    .with({ filterName: 'patient_state_name_filter' }, () => ({
      customComponent: PatientStateComponent,
    }))
    .with({ filterName: 'patient_facility_name_filter' }, () => ({
      customComponent: PatientFacilityComponent,
      vectorField: 'facility',
    }))
    .with({ filterName: 'patient_gender_filter' }, () => ({
      customComponent: PatientGenderComponent,
    }))
    .with({ filterName: 'age_range_filter' }, () => ({
      customComponent: AgeRangeComponent,
    }))
    .with({ filterName: 'years_practiced_range_filter' }, () => ({
      customComponent: YearsPracticedRangeComponent,
    }))
    .with({ filterName: 'net_worth_filter' }, () => ({
      customComponent: NetWorthComponent,
    }))
    .with({ filterName: 'state_name_filter' }, () => ({
      customComponent: StateNameComponent,
    }))
    .otherwise(() => null);

  return (filterConfigExtension ? { ...filter, ...filterConfigExtension } : filter) as FilterConfigItem;
};

export default extendFilter;
